export const initialState = {
    shipdetails: [],
    status:"",
    selectedShipId: null,
    selectedOwner:null
    };
    